module.exports = __webpack_public_path__ + "img/Googlelogo.5438f770.png";